import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";
import { firebaseConfig as devConfig } from "./firebaseConfig.dev";
import { firebaseConfig as testConfig } from "./firebaseConfig.test";
import { firebaseConfig as prodConfig } from "./firebaseConfig.prod";
import { getDatabase } from 'firebase/database';

const env = process.env.REACT_APP_ENV || "dev";

export const firebaseConfig =
  env === "test" ? testConfig : (env === "prod" ? prodConfig : devConfig);
  
console.log("selected config ====> ", env)
const app = initializeApp(firebaseConfig);

export const functions = getFunctions(app, "us-central1");

export const auth = getAuth(app);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
export let analytics: any = null;



isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});
